import StatusPill from '../StatusPill'
import styles from './BotBadge.module.scss'

/** Marks a bot account (Arc, Dwight Bot, …) wherever one is listed beside people. */
const BotBadge = () => (
  <StatusPill tone="neutral" className={styles.botBadge} data-cy="bot-badge">
    Bot
  </StatusPill>
)

export default BotBadge
